import { ThumbsUp, ArrowsClockwise, PencilSimple, Star, Handshake } from "@phosphor-icons/react";

const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }); } catch { return iso; }
};

const Block = ({ n, icon: Icon, title, value, accent }) => (
  <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
    <div className="px-5 py-3 border-b border-slate-100 flex items-center gap-2">
      <span className={`font-mono text-xs font-bold ${accent}`}>STEP {n}</span>
      <Icon size={16} weight="duotone" className={accent} />
      <h3 className="text-sm font-semibold tracking-wide uppercase text-slate-700">{title}</h3>
    </div>
    <div className="p-5">
      <p className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">{value || <span className="text-slate-300">—</span>}</p>
    </div>
  </div>
);

export default function CoachingBlueprint({ doc }) {
  const p = doc.payload || {};
  return (
    <div className="space-y-4" data-testid="coaching-blueprint">
      <div className="bg-white border border-slate-200 rounded-sm p-5">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.08em] uppercase text-slate-400 mb-1">Recipient</p>
            <p className="text-sm font-medium text-slate-900">{p.subject || <span className="text-slate-300">—</span>}</p>
          </div>
          <div>
            <p className="text-xs font-semibold tracking-[0.08em] uppercase text-slate-400 mb-1">Role</p>
            <p className="text-sm text-slate-700">{p.role || <span className="text-slate-300">—</span>}</p>
          </div>
          <div>
            <p className="text-xs font-semibold tracking-[0.08em] uppercase text-slate-400 mb-1">Review Date</p>
            <p className="text-sm text-slate-700 font-mono">{fmtDate(p.reviewDate)}</p>
          </div>
        </div>
      </div>

      <Block n={1} icon={ThumbsUp} title="Working Well — Self" value={p.selfWell} accent="text-emerald-700" />
      <Block n={2} icon={ArrowsClockwise} title="Do Differently — Self" value={p.selfDifferently} accent="text-emerald-700" />
      <Block n={3} icon={PencilSimple} title="Do Differently — Coach" value={p.coachDifferently} accent="text-emerald-700" />
      <Block n={4} icon={Star} title="Doing Well — Coach" value={p.coachWell} accent="text-emerald-700" />

      {p.actionPlan && (
        <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-slate-100 flex items-center gap-2">
            <Handshake size={16} weight="duotone" className="text-emerald-700" />
            <h3 className="text-sm font-semibold tracking-wide uppercase text-slate-700">Agreed Action Plan</h3>
          </div>
          <div className="p-5"><p className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">{p.actionPlan || <span className="text-slate-300">—</span>}</p></div>
        </div>
      )}

      {p.owner && (
        <div className="bg-white border border-slate-200 rounded-sm p-5">
          <p className="text-xs font-semibold tracking-[0.08em] uppercase text-slate-400 mb-1">Accountable Owner</p>
          <p className="text-sm font-medium text-slate-900">{p.owner}</p>
        </div>
      )}
    </div>
  );
}
